import React from 'react';

/**
 * 2025-06 fully modernized
 *
 * Show the mat shape image for one lloydItem.
 */
export default function LloydMatImage({lloydItem}) {
  let {mediaList = []} = lloydItem;

  let image = mediaList[0];
  if (!image)
    return (<div className="error">(no images)</div>);

  return (<div className="text-center"><img
    className="block mx-auto max-h-40"
    src={image}
    alt="Floor Mat Diagram"/></div>);
}
